import { ERouterList } from '@internal/router/constants/router-list'

import LoginLayout from '@internal/layouts/login-layout.vue'

import { guest } from '@internal/router/middleware/guest'
import { unknown } from '@internal/router/middleware/unknown'

export const authPage = [
  {
    path: '/login',
    name: ERouterList.LOGIN,
    component: () => import('@internal/pages/login/index.vue'),
    meta: {
      middleware: [guest],
      layout: LoginLayout,
    },
  },
  {
    path: '/login/:email',
    name: ERouterList.LOGIN_EMAIL,
    component: () => import('@internal/pages/login/_email.vue'),
    meta: {
      middleware: [guest],
      layout: LoginLayout,
    },
  },
  {
    path: '/forgot-password',
    name: ERouterList.FORGOT_PASSWORD,
    component: () => import('@internal/pages/forgot-password.vue'),
    meta: {
      middleware: [guest],
      layout: LoginLayout,
    },
  },
  {
    path: '/new-password',
    name: ERouterList.NEW_PASSWORD,
    component: () => import('@internal/pages/new-password.vue'),
    meta: {
      middleware: [guest],
      layout: LoginLayout,
    },
  },
  {
    path: '/forgot-password-verification',
    name: ERouterList.FORGOT_PASSWORD_VRF,
    component: () => import('@internal/pages/forgot-password-verification.vue'),
    meta: {
      middleware: [guest],
      layout: LoginLayout,
    },
  },
  {
    path: '/creating-account-via-link',
    name: ERouterList.CREATING_ACCOUNT_VIA_LINK,
    component: () => import('@internal/pages/creating-account-via-link.vue'),
  },
  {
    path: '/redirects/:token',
    name: ERouterList.REDIRECTS,
    component: () => import('@/internal/src/pages/redirects/_token.vue'),
    meta: {
      middleware: [unknown],
    },
  },
]

export default authPage
